import { Rokojori } from "./js/Rokojori";

function main()
{
  let rokojori = Rokojori.$; 
} 

window.addEventListener
(
  "load", main 
)